const uuidRegexpPattern =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
const uuidRegexp = new RegExp(uuidRegexpPattern, 'gi')

//Названия маршрутов
export const MailClientRoute = 'MailService.Client'
export const MailClientAccountRoute = 'MailService.Client.Account'
export const MailClientFolderRoute = 'MailService.Client.Folder'
export const MailClientMessageRoute = 'MailService.Client.Mail'
export const MailClientComposeRoute = 'MailService.Client.Compose'
export const MailClientSettingsRoute = 'MailService.Client.Settings'
export const MailClientSettingsSignaturesRoute =
  'MailService.Client.Settings.Signatures'
export const MailClientSettingsFoldersRoute =
  'MailService.Client.Settings.Folders'
export const MailManagementRoute = 'MailService.Management'

//Навигация
export default [
  {
    path:"",
    redirect:"client",
  },
  {
    path: 'client',
    name: MailClientRoute,
    component: () => import('@/apps/mail/modules/client/index'),
    children: [
      {
        name: MailClientAccountRoute,
        path: `acc-:acc(${uuidRegexpPattern})`,
        component: () => import('@/apps/mail/modules/client/views/Account'),
        children: [
          {
            name: MailClientFolderRoute,
            path: `b-:bid(${uuidRegexpPattern})`,
            component: () => import('@/apps/mail/modules/client/views/Box')
          },
          {
            name: MailClientMessageRoute,
            path: `m-:mid(${uuidRegexpPattern})`,
            component: () => import('@/apps/mail/modules/client/views/Message')
          },
          {
            name: MailClientComposeRoute,
            path: `compose/:draft_id?`,
            component: () => import('@/apps/mail/modules/client/views/Compose')
          }
        ]
      }
    ]
  },
  {
    path: `settings`,
    name: MailClientSettingsRoute,
    component: () => import('@/apps/mail/modules/settings'),
    redirect: 'settings/signatures',
    children: [
      {
        name: MailClientSettingsSignaturesRoute,
        path: `signatures`,
        component: () => import('@/apps/mail/modules/settings/views/Signatures')
      },
      {
        name: MailClientSettingsFoldersRoute,
        path: `folders/:account?`,
        component: () => import('@/apps/mail/modules/settings/views/Folders')
      }
    ]
  },
  {
    path: `management`,
    name: MailManagementRoute,
    component: () => import('@/apps/mail/modules/management')
  }
]



// WEBPACK FOOTER //
// ./src/apps/mail/routes/index.js